import { AxiosError } from 'axios';

export class ErrorCode extends AxiosError {
}
